const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
const SEXTET = new Map(Array.from(ALPHABET, (char, index) => [char, index]));
// Pure JS: atob, Buffer and TextDecoder are not guaranteed on every Hermes build.
export function decodeBase64UrlToString(segment) {
    if (segment.length % 4 === 1)
        throw new Error("Invalid base64url length");
    const bytes = [];
    let buffer = 0;
    let bits = 0;
    for (const char of segment) {
        const sextet = SEXTET.get(char);
        if (sextet === undefined)
            throw new Error("Invalid base64url character");
        buffer = (buffer << 6) | sextet;
        bits += 6;
        if (bits >= 8) {
            bits -= 8;
            bytes.push((buffer >> bits) & 0xff);
            buffer &= (1 << bits) - 1;
        }
    }
    return decodeUtf8(bytes);
}
function decodeUtf8(bytes) {
    let text = "";
    for (let i = 0; i < bytes.length;) {
        const lead = bytes[i++];
        let extra;
        let codePoint;
        let min;
        if (lead < 0x80) {
            text += String.fromCharCode(lead);
            continue;
        }
        else if (lead >= 0xc2 && lead <= 0xdf) {
            extra = 1;
            codePoint = lead & 0x1f;
            min = 0x80;
        }
        else if (lead >= 0xe0 && lead <= 0xef) {
            extra = 2;
            codePoint = lead & 0x0f;
            min = 0x800;
        }
        else if (lead >= 0xf0 && lead <= 0xf4) {
            extra = 3;
            codePoint = lead & 0x07;
            min = 0x10000;
        }
        else {
            throw new Error("Invalid UTF-8 lead byte");
        }
        for (let n = 0; n < extra; n++) {
            const next = bytes[i++];
            if (next === undefined || (next & 0xc0) !== 0x80) {
                throw new Error("Invalid UTF-8 continuation byte");
            }
            codePoint = (codePoint << 6) | (next & 0x3f);
        }
        if (codePoint < min || codePoint > 0x10ffff || (codePoint >= 0xd800 && codePoint <= 0xdfff)) {
            throw new Error("Invalid UTF-8 code point");
        }
        text += String.fromCodePoint(codePoint);
    }
    return text;
}
